import { ROUTES } from "const";
import { courseService } from "libs/api";
import { CourseHelper } from "libs/helpers";

export class ABILITAZIONE60CFUMANIFESTO {

  static async getDashboardCards(courseCode, registrationCode, aa) {
    let cards = this.getFixedCards(courseCode, aa);
    const result = await courseService.perfezionamentoActiveLink(
      registrationCode
    );
    if (result.data.payload) {
      const { payload } = result.data;
      try {
        if (payload.SelfDeclarationEnabled === "1") {
          cards.push({
            title: "Autocertificazione d'iscrizione",
            link: ROUTES.USER_SELF_DECLARATION,
            img: "/img/icon/badge.png",
            className: "image-box",
          });
        }


        if (payload.activeSurvey && payload.activeSurvey.length > 0) {
          cards.push({
            title: payload.activeSurvey,
            link: ROUTES.COURSE_SURVEY_MAIN + "/" + payload.activeSurvey,
            img: "/img/icon/call.png",
            className: "image-box",
          });
        }

        if (result.data.payload.examReservationEnabled === "1") {
          cards.push({
            title: 'Prenotazione prova finale',
            link: ROUTES.CFUALL_EXAM_RESERVATION,
            img: '/img/icon/7.webp',
            className: 'image-box'
          });
        }

        if (result.data.payload.enableUDA === "1") {

          cards.push({
            title: "Prova scritta",
            link: ROUTES.COURSE_CFU60ALL1_UDA_EXAMWRITTEN,
            img: "/img/icon/examdone.png",
            className: "image-box",
          });
        }

        if (result.data.payload.enableExamSubject === "1") {
          cards.push({
            title: "Argomento Lezione Simulata",
            link: ROUTES.COURSE_RC30_EXAM_SUBJECT,
            img: "/img/icon/7.png",
            className: "image-box",
          });
        }

        if (CourseHelper.isUnicamillus(courseCode) && payload.titleRequestEnabled === "1") {
          cards.push({
            title: 'Certificato Finale',
            link: ROUTES.MU_UM_TITLE_DONWLOAD,
            img: '/img/icon/graduate.png',
            className: 'image-box'
          });
        }

        if (CourseHelper.isIUL(courseCode) && payload.titleRequestEnabled === "1") {
          if (payload.titleRequestEnabled === "1") {
            cards.push({
              title: 'Certificato Finale',
              link: ROUTES.MU_COURSE_TITLE_REQUEST,
              img: '/img/icon/graduate.png',
              className: 'image-box'
            });
          }
        }

        if (payload.certRequestEnabled === "1") {
          cards.push({
            title: "Consultazione Esito Finale",
            link: ROUTES.COURSE_RC30_CERT_REQUEST,
            img: "/img/icon/1.png",
            className: "image-box",
          });
        }
      } catch (error) { }
    }
    return cards;
  }

  static getFixedCards(courseCode, aa) {
    if (aa < 2025) {
      if (CourseHelper.isUnitelma(courseCode)) {
        return [
          {
            title: "Situazione pagamenti",
            link: ROUTES.COURSE_PAYMENTS,
            img: "/img/icon/payment.png",
            className: "image-box",
          },
          {
            title: "Materiale Didattico",
            link: ROUTES.COURSE_LESSONLIVE_MATERIALS,
            img: "/img/icon/icon_monitor.png",
            className: "image-box",
          },
          {
            title: "Attività Formative",
            link: ROUTES.COURSE_LESSONSECTIONGROUP_SCHEDULE,
            img: "/img/icon/3.png",
            className: "image-box",
          },
          {
            title: "Lezioni telematiche in modalità sincrona",
            link: ROUTES.COURSE_LESSONLIVE_SCHEDULE_ONLINE_ALL,
            img: "/img/icon/presentation.png",
            className: "image-box",
          },
          {
            title: "Tirocinio Indiretto",
            link: ROUTES.COURSE_LESSONTRAINING_SCHEDULE,
            img: "/img/icon/8.webp",
            className: "image-box",
          },
          {
            title: "Lezioni in presenza",
            link: ROUTES.COURSE_LESSONONSITE_SCHEDULE,
            img: "/img/icon/3.png",
            className: "image-box",
          },
          {
            title: "Tirocinio diretto",
            link: ROUTES.COURSE_TIROCINIODIRETTO_DETAIL,
            img: "/img/icon/8.webp",
            className: "image-box",
          },
          {
            title: "Badge Accesso Aula",
            link: ROUTES.MY_BADGE,
            img: "/img/icon/1.png",
            className: "image-box",
          }];
      } else if (CourseHelper.isReggioAbilitazione(courseCode)) {
        return [
          {
            title: "Situazione pagamenti",
            link: ROUTES.COURSE_PAYMENTS,
            img: "/img/icon/payment.png",
            className: "image-box",
          },
          {
            title: "Attività Formative",
            link: ROUTES.COURSE_LESSONSECTION_SCHEDULE,
            img: "/img/icon/3.png",
            className: "image-box",
          },
          {
            title: "Lezioni telematiche in modalità sincrona",
            link: ROUTES.COURSE_LESSONLIVE_SCHEDULE_ONLINE_ALL,
            img: "/img/icon/presentation.png",
            className: "image-box",
          },
          {
            title: "Tirocinio Indiretto",
            link: ROUTES.COURSE_LESSONTRAINING_SCHEDULE,
            img: "/img/icon/8.webp",
            className: "image-box",
          },
          {
            title: "Lezioni in presenza",
            link: ROUTES.COURSE_LESSONONSITE_SCHEDULE,
            img: "/img/icon/3.png",
            className: "image-box",
          },
          {
            title: "Tirocinio diretto",
            link: ROUTES.COURSE_TIROCINIODIRETTO_DETAIL,
            img: "/img/icon/8.webp",
            className: "image-box",
          },
          {
            title: "Badge Accesso Aula",
            link: ROUTES.MY_BADGE,
            img: "/img/icon/1.png",
            className: "image-box",
          }];
      } else {
        return [
          {
            title: "Situazione pagamenti",
            link: ROUTES.MU_COURSE_PAYMENTS,
            img: "/img/icon/payment.png",
            className: "image-box",
          },
          {
            title: "Attività Formative",
            link: ROUTES.COURSE_LESSONSECTION_SCHEDULE,
            img: "/img/icon/3.png",
            className: "image-box",
          },
          {
            title: "Lezioni telematiche in modalità sincrona",
            link: ROUTES.COURSE_LESSONLIVE_SCHEDULE_ONLINE_ALL,
            img: "/img/icon/presentation.png",
            className: "image-box",
          },
          {
            title: "Tirocinio Indiretto",
            link: ROUTES.COURSE_LESSONTRAINING_SCHEDULE,
            img: "/img/icon/8.webp",
            className: "image-box",
          },
          {
            title: "Lezioni in presenza",
            link: ROUTES.COURSE_LESSONONSITE_SCHEDULE,
            img: "/img/icon/3.png",
            className: "image-box",
          },
          {
            title: "Badge Accesso Aula",
            link: ROUTES.MY_BADGE,
            img: "/img/icon/1.png",
            className: "image-box",
          },
        ];
      }
    } else {
      if (CourseHelper.isUnitelma(courseCode) || CourseHelper.isReggioAbilitazione(courseCode)) {
        return [
          {
            title: "Situazione pagamenti",
            link: ROUTES.COURSE_PAYMENTS,
            img: "/img/icon/payment.png",
            className: "image-box",
          },
        ];
      } else {
        return [
          {
            title: "Situazione pagamenti",
            link: ROUTES.MU_COURSE_PAYMENTS,
            img: "/img/icon/payment.png",
            className: "image-box",
          },
          {
            title: "Tirocinio diretto",
            link: ROUTES.COURSE_TIROCINIODIRETTO_DETAIL,
            img: "/img/icon/8.webp",
            className: "image-box",
          },
        ];
      }
    }

  }

  static getDashboardNotices(courseCode, competitionClass, aa) {
    if (aa < 2025) {
      if (CourseHelper.isIUL(courseCode) && courseCode.startsWith('IUL60ALL1')) {
        return [
          {
            title: `Modalità di svolgimento della prova finale`,
            content: `<p><a href="https://www.formazionedocenti.it/files/corsi/IUL306036/Modalita_svolgimento_prova_finale_60CFU_ALL1_IUL.pdf" target="_blank">Clicca qui per scaricare le modalità di svolgimento della prova finale</a></p>`,
          },
          {
            title: `Svolgimento tirocinio diretto`,
            content: `Al fine di procedere con l’individuazione dell’istituzione scolastica per lo svolgimento del tirocinio diretto è necessario inoltrare, <br/>
          debitamente compilato e sottoscritto, il <a href="https://www.formazionedocenti.it/files/corsi/IUL306036/Modulo_raccolta_dati_tirocinio_diretto_60-36CFU_IUL36ALL5.pdf" target="_blank">
          Modulo raccolta dati dell’Ente ospitante</a> esclusivamente all’indirizzo mail: <br/><br/>
          <a href="mailto:tirocinio.formazionedocenti@iuline.it"><b>tirocinio.formazionedocenti@iuline.it</b></a><br/><br/>
          Ogni altra comunicazione per richiedere informazioni connesse alle attività di tirocinio dovrà essere <b>esclusivamente</b> inviata 
          all’Università al suddetto indirizzo mail.`
          },
          {
            title: `Indicazioni sullo svolgimento del tirocinio`,
            content: `<a href="/assets/doc/Nota-MIM-MUR-28giu2024-7845-Percorsi-di-formaz-iniziale-docenti-Secondarie-2023-24.pdf"" target="_blank">Clicca qui per scaricare il file</a>`
          },
          {
            title: `Sedi lezioni in presenza e tirocinio indiretto`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/IUL306036/SEDE_TIROCINI_INDIRETTI_IUL.pdf" target="_blank">Clicca qui per scaricare il file</a>`
          },
          {
            content: `<p>Linee guida per lo svolgimento delle lezioni in modalità telematica sincrona. 
            <a href="https://www.formazionedocenti.it/files/corsi/603036cfu/linee-guida-lezioni-60.pdf" target="_blank">Clicca qui per scaricare le linee guida</a></p>`,
          }

        ];
      }
      else if (CourseHelper.isIUL(courseCode)) {
        return [
          {
            title: `Modalità di svolgimento della prova finale`,
            content: `<p><a href="https://www.formazionedocenti.it/files/corsi/IUL306036/Modalita_svolgimento_prova_finale_60CFU_ALL1_IUL.pdf" target="_blank">Clicca qui per scaricare le modalità di svolgimento della prova finale</a></p>`,
          },
          {
            title: `Indicazioni sullo svolgimento del tirocinio`,
            content: `<a href="/assets/doc/Nota-MIM-MUR-28giu2024-7845-Percorsi-di-formaz-iniziale-docenti-Secondarie-2023-24.pdf"" target="_blank">Clicca qui per scaricare il file</a>`
          },
          {
            title: `Sedi lezioni in presenza e tirocinio indiretto`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/IUL306036/SEDE_TIROCINI_INDIRETTI_IUL.pdf" target="_blank">Clicca qui per scaricare il file</a>`
          },
          {
            content: `<p>Linee guida per lo svolgimento delle lezioni in modalità telematica sincrona. 
            <a href="https://www.formazionedocenti.it/files/corsi/603036cfu/linee-guida-lezioni-60.pdf" target="_blank">Clicca qui per scaricare le linee guida</a></p>`,
          }
        ];
      } else if (CourseHelper.isUnicamillus(courseCode)) {
        return [
          {
            title: `Linee guida alla redazione della Relazione Tirocinio Diretto `,
            content: `<p><a href="https://www.formazionedocenti.it/files/corsi/603036cfu/Linee_guida_alla_redazione_della_Relazione_Tirocinio_Diretto.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>`,
          },
          {
            title: `Modalità di svolgimento della prova finale`,
            content: `<p><a href="https://www.formazionedocenti.it/files/corsi/UM306036/Modalita_svolgimento_prova_finale_60CFU_ALL1_UNICAMILLUS.pdf" target="_blank">Clicca qui per scaricare le modalità di svolgimento della prova finale</a></p>`,
          },
          {
            title: `Indicazioni sullo svolgimento del tirocinio`,
            content: `<a href="/assets/doc/Nota-MIM-MUR-28giu2024-7845-Percorsi-di-formaz-iniziale-docenti-Secondarie-2023-24.pdf"" target="_blank">Clicca qui per scaricare il file</a>`
          },
          {
            title: `Sedi lezioni in presenza e tirocinio indiretto`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/UM306036/SEDE_TIROCINI_INDIRETTI_UNICAMILLUS.pdf" target="_blank">Clicca qui per scaricare il file</a>`,
          },
          {
            content: `<p>Linee guida per lo svolgimento delle lezioni in modalità telematica sincrona. 
            <a href="https://www.formazionedocenti.it/files/corsi/603036cfu/linee-guida-lezioni-60.pdf" target="_blank">Clicca qui per scaricare le linee guida</a></p>`,
          }
        ];
      } else if (CourseHelper.isUnitelmaAbilitazione(courseCode)) {
        return [
          {
            title: `Modalità di svolgimento della prova finale`,
            content: `<p><a href="https://www.formazionedocenti.it/files/corsi/UNT3060/Modalita_svolgimento_prova_finale_60CFU_ALL1_UNITELMA.pdf" target="_blank">Clicca qui per scaricare le modalità di svolgimento della prova finale</a></p>`,
          },
          {
            title: `Proroga conclusione tirocinio diretto`,
            content: `<p>Si informano gli studenti che il termine ultimo di conclusione del tirocinio diretto è stato prorogato al 27 ottobre 2025.</p>`,
          },
          {
            title: `Linee guida alla redazione della Relazione Tirocinio Diretto `,
            content: `<p><a href="https://www.formazionedocenti.it/files/corsi/603036cfu/Linee_guida_alla_redazione_della_Relazione_Tirocinio_Diretto.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>`,
          },
          {
            content: `<p>Si informano gli studenti che le percentuali delle presenze verranno aggiornate entro 24ore dall’avvenuto svolgimento della lezione.</p>`
          },
          {
            content: `<p>Linee guida per lo svolgimento delle lezioni in modalità telematica sincrona. 
            <a href="https://www.formazionedocenti.it/files/corsi/603036cfu/linee_guida_per_lo_studente_RC_UNT.pdf" target="_blank">Clicca qui per scaricare le linee guida</a></p>`,
          },
          {
            title: `Calendario Attività Didattiche in presenza`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/UNT3060/calendario_attivita_60.pdf" target="_blank">Clicca qui per scaricare il file</a>`
          },
          {
            title: `Prospetto Frequenza (aggiornato all’8 Agosto 2025)`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/UNT3060/ProspettoFrequenzaUNT60CFUAll1.pdf" target="_blank">Clicca qui per scaricare l'informativa</a>`,
          },
          {
            title: `Indicazioni sullo svolgimento del tirocinio`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/UNT3060/Nota-MIM-MUR-28giu2024-7845-Percorsi-di-formaz-iniziale-docenti-Secondarie-2023-24.pdf" target="_blank">Nota MIM-MUR</a>
          <br>
          <a href="https://www.formazionedocenti.it/files/corsi/UNT3060/Osservazioni sul Tirocinio diretto 290825_02.pdf" target="_blank">Osservazioni</a>
          <br>
          <p>Al fine di poter rispettare il termine di conclusione dei percorsi indicato dal Ministero, il tirocinio diretto dovrà concludersi entro e non oltre il 20 ottobre 2025.</p>`,
          }
        ];
      } else if (CourseHelper.isReggioAbilitazione(courseCode)) {
        return [
          {
            title: `Modalità di svolgimento della prova finale`,
            content: `<p><a href="https://www.formazionedocenti.it/files/corsi/RC3060/Modalita_svolgimento_prova_finale_60CFU_ALL1_REGGIO.pdf" target="_blank">Clicca qui per scaricare le modalità di svolgimento della prova finale</a></p>`,
          },
          {
            title: `Proroga conclusione tirocinio diretto`,
            content: `<p>Si informano gli studenti che il termine ultimo di conclusione del tirocinio diretto è stato prorogato al 27 ottobre 2025.</p>`,
          },
          {
            title: `Linee guida alla redazione della Relazione Tirocinio Diretto `,
            content: `<p><a href="https://www.formazionedocenti.it/files/corsi/603036cfu/Linee_guida_alla_redazione_della_Relazione_Tirocinio_Diretto.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>`,
          },
          {
            content: `<p>Si informano gli studenti che le percentuali delle presenze verranno aggiornate entro 24ore dall’avvenuto svolgimento della lezione.</p>`
          },
          {
            content: `<p>Linee guida per lo svolgimento delle lezioni in modalità telematica sincrona. 
            <a href="https://www.formazionedocenti.it/files/corsi/603036cfu/linee_guida_per_lo_studente_RC_UNT.pdf" target="_blank">Clicca qui per scaricare le linee guida</a></p>`,
          },
          {
            title: `Calendario Attività Didattiche in presenza`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/RC3060/Calendario_Attivit_Didattiche_in presenza_60CFU.pdf" target="_blank">Clicca qui per scaricare il file</a>`
          },
          {
            title: `Prospetto Frequenza`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/RC3060/ProspettoFrequenzaRC60CFUAll1.pdf" target="_blank">Clicca qui per scaricare l'informativa</a>`,
          },
          {
            title: `Indicazioni sullo svolgimento del tirocinio`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/RC3060/Nota-MIM-MUR-28giu2024-7845-Percorsi-di-formaz-iniziale-docenti-Secondarie-2023-24.pdf" target="_blank">Nota MIM-MUR</a>
          <br>
          <a href="https://www.formazionedocenti.it/files/corsi/RC3060/OsservazionisulTirociniodiretto290825_02.pdf" target="_blank">Osservazioni</a>
          <br>
          <p>Al fine di poter rispettare il termine di conclusione dei percorsi indicato dal Ministero, il tirocinio diretto dovrà concludersi entro e non oltre il 20 ottobre 2025.</p>`,
          }
        ];
      }
    } else {
      if (CourseHelper.isReggioAbilitazione(courseCode)) {
        return [
          {
            title: `Sedi lezioni in presenza`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/RC3060/Sedi_Dante_Alighieri_lezioni_in_presenza.pdf" target="_blank">Clicca qui per scaricare il file</a>`
          },
        ];
      } else if (CourseHelper.isUnitelmaAbilitazione(courseCode)) {
        return [
          {
            title: `Sedi lezioni in presenza`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/UNT3060/Sedi_Unitelma_lezioni_in_presenza.pdf" target="_blank">Clicca qui per scaricare il file</a>`
          },
          {
            title: `Sedi e Indirizzi lezioni in presenza`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/UNT3060/Sedi_e_indirizzi_Unitelma_lezioni_in_presenza.pdf" target="_blank">Clicca qui per scaricare il file</a>`
          },
        ];

      } else if (CourseHelper.isUnicamillus(courseCode)) {
        return [
          {
            title: `Sedi lezioni in presenza`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/UM306036/Sedi_Unicamillus_lezioni_in_presenza.pdf" target="_blank">Clicca qui per scaricare il file</a>`
          },
          {
            title: `Sedi e Indirizzi lezioni in presenza`,
            content: `<a href="https://www.formazionedocenti.it/files/corsi/UM306036/Sedi_e_indirizzi_Unicamillus_lezioni_in_presenza_60CFU.pdf" target="_blank">Clicca qui per scaricare il file</a>`
          },
        ];

      }

    }
  }
}
